import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';
import NotFound from '@/pages/NotFound';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articleData.find((a) => a.slug === slug);

  if (!article) {
    return <NotFound />;
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <ArticleLayout article={article} />
      </main>
      <Footer />
    </div>
  );
}